import { createContext } from 'react';

export const MenuContext = createContext({
  selectedMenuItem: {},
  fetchedMenu: undefined,
  fetchMenuSectionsList: undefined,
});
